import type { CommandContext } from '../types';

type GridRow = Record<string, unknown>;

/** Error of a Wise command when the grid cannot ask the user to confirm it. */
export const CONFIRMATION_UNAVAILABLE = 'Confirmation dialog is not available';

/** Positive integer invoice id, or 0 for anything else. */
export const toInvoiceId = (value: unknown): number => {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : 0;
};

/** Selected invoice ids of the grid, in selection order. */
export const getSelectedInvoiceIds = (context: CommandContext): number[] =>
  Array.from(context.selectedRows ?? [])
    .map((id) => toInvoiceId(id))
    .filter((id) => id > 0);

/** Rows as the user sees them, falling back to the raw grid data. */
export const getGridRows = (context: CommandContext): GridRow[] =>
  context.displayData?.length ? context.displayData : context.gridData;

export const findInvoiceRow = (
  rows: GridRow[] | undefined,
  invoiceId: number
): GridRow | undefined =>
  rows?.find((row) => toInvoiceId(row.Id ?? row.CrmInvoiceId) === invoiceId);

export const invoiceLabel = (row: GridRow | undefined, invoiceId: number): string =>
  String(row?.CrmNumber ?? `#${invoiceId}`);
